import { render } from "./InformacionGeneralInspeccionComponent.vue?vue&type=template&id=20e1ebcf&scoped=true"
import script from "./InformacionGeneralInspeccionComponent.vue?vue&type=script&lang=js"
export * from "./InformacionGeneralInspeccionComponent.vue?vue&type=script&lang=js"

import "./InformacionGeneralInspeccionComponent.vue?vue&type=style&index=0&id=20e1ebcf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20e1ebcf"]])

export default __exports__